import React from 'react'

const SunroofMoonroof = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <circle fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={244.364} cy={239.507} r={111.232} />
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M353.216 468.1c-20.326 0-40.057-5.813-57.058-16.812a105.895 105.895 0 0 1-38.155-43.503 10 10 0 0 1 14.127-12.895c13.207 7.819 28.22 11.953 43.416 11.953 47.126 0 85.465-38.34 85.465-85.466 0-12.646-2.798-24.949-8.316-36.566a9.998 9.998 0 0 1 9.034-14.291c1.751 0 3.511.458 5.093 1.396 31.988 18.94 51.859 53.702 51.859 90.721 0 58.151-47.312 105.463-105.465 105.463zM130.319 233.433h-95.29M165.328 156.919L92.274 83.865M244.07 125.599V32M324.856 158.027l68.781-68.781M163.737 321.801l-63.427 63.427"
    />
  </svg>
)
export default SunroofMoonroof
